import React, { useState, useEffect } from 'react';
import Layout from '../../components/Layout';
import api from '../../utils/api';
import toast from 'react-hot-toast';

export default function AdminPagamentos() {
  const [pagamentos, setPagamentos] = useState([]);
  const [filtro, setFiltro] = useState('aguardando_analise');
  const [loading, setLoading] = useState(true);

  const buscar = () => {
    setLoading(true);
    const q = filtro ? `?status=${filtro}` : '';
    api.get(`/admin/pagamentos${q}`)
      .then(r => setPagamentos(r.data.pagamentos || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => { buscar(); }, [filtro]);

  const aprovar = async (id, plano = '30_dias') => {
    try {
      await api.post(`/admin/pagamentos/${id}/aprovar`, { plano_override: plano });
      toast.success('✅ Acesso liberado por 30 dias! E-mail enviado à empresa.');
      buscar();
    } catch (err) {
      toast.error(err.response?.data?.erro || 'Erro ao aprovar.');
    }
  };

  const rejeitar = async (id) => {
    const motivo = window.prompt('Motivo da rejeição:');
    if (!motivo) return;
    try {
      await api.post(`/admin/pagamentos/${id}/rejeitar`, { motivo });
      toast.success('Pagamento rejeitado.');
      buscar();
    } catch { toast.error('Erro ao rejeitar.'); }
  };

  const statusCor = {
    'aguardando_analise': 'badge-orange',
    'aprovado':           'badge-green',
    'rejeitado':          'badge-red',
    'pendente':           'badge-gray',
  };

  return (
    <Layout title="Gerenciar Pagamentos" subtitle="Aprove comprovantes e libere acesso de 30 dias">

      {/* Filtro */}
      <div className="flex gap-2 mb-5 flex-wrap">
        {[['aguardando_analise','⏳ Aguardando'],['aprovado','✅ Aprovados'],['rejeitado','❌ Rejeitados'],['','📋 Todos']].map(([val, label]) => (
          <button key={val} onClick={() => setFiltro(val)}
            className={`px-4 py-2 rounded-xl text-xs font-semibold border transition-all
              ${filtro === val ? 'bg-acre-green text-white border-acre-green' : 'bg-white text-gray-500 border-gray-200 hover:border-acre-green'}`}>
            {label}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="text-center py-16 text-gray-400">Carregando...</div>
      ) : !pagamentos.length ? (
        <div className="card p-10 text-center">
          <p className="text-4xl mb-2">✅</p>
          <p className="text-gray-500">Nenhum pagamento com esse status.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {pagamentos.map(p => (
            <div key={p.id} className="card p-5">
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <h3 className="font-sora font-semibold text-acre-dark">{p.razao_social}</h3>
                    <span className={statusCor[p.status] || 'badge-gray'}>{p.status?.replace('_',' ')}</span>
                  </div>
                  <p className="text-xs text-gray-400">
                    {p.cnpj} · {p.contato} · {p.email}
                  </p>
                  <p className="text-xs text-gray-400 mt-1">
                    Solicitado: {new Date(p.data_solicitacao).toLocaleDateString('pt-BR')}
                    {p.data_aprovacao && ` · Aprovado: ${new Date(p.data_aprovacao).toLocaleDateString('pt-BR')}`}
                  </p>
                  {p.comprovante_url && (
                    <a href={`${process.env.REACT_APP_API_URL?.replace('/api','')}${p.comprovante_url}`}
                      target="_blank" rel="noreferrer"
                      className="text-xs text-blue-500 hover:underline mt-1 inline-block">
                      📎 Ver comprovante
                    </a>
                  )}
                </div>

                {p.status === 'aguardando_analise' && (
                  <div className="flex gap-2 flex-shrink-0">
                    <button onClick={() => rejeitar(p.id)}
                      className="px-3 py-2 text-xs font-semibold border border-red-200 text-red-500 rounded-xl hover:bg-red-50 transition-colors">
                      Rejeitar
                    </button>
                    <button onClick={() => aprovar(p.id)}
                      className="btn-primary text-xs px-4 py-2">
                      ✅ Liberar 30 dias
                    </button>
                  </div>
                )}
                {p.status === 'aprovado' && p.data_expiracao && (
                  <div className="text-right flex-shrink-0">
                    <p className="text-xs text-gray-400">Expira em</p>
                    <p className="font-sora font-semibold text-sm text-acre-green">
                      {new Date(p.data_expiracao).toLocaleDateString('pt-BR')}
                    </p>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </Layout>
  );
}
